/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegressionSignal
 */
export interface RegressionSignal {
    /**
     * 
     * @type {string}
     * @memberof RegressionSignal
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof RegressionSignal
     */
    severity?: string;
    /**
     * 
     * @type {number}
     * @memberof RegressionSignal
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof RegressionSignal
     */
    message?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RegressionSignal
     */
    details?: { [key: string]: string; };
}

/**
 * Check if a given object implements the RegressionSignal interface.
 */
export function instanceOfRegressionSignal(value: object): value is RegressionSignal {
    return true;
}

export function RegressionSignalFromJSON(json: any): RegressionSignal {
    return RegressionSignalFromJSONTyped(json, false);
}

export function RegressionSignalFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegressionSignal {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'count': json['count'] == null ? undefined : json['count'],
        'message': json['message'] == null ? undefined : json['message'],
        'details': json['details'] == null ? undefined : json['details'],
    };
}

export function RegressionSignalToJSON(json: any): RegressionSignal {
    return RegressionSignalToJSONTyped(json, false);
}

export function RegressionSignalToJSONTyped(value?: RegressionSignal | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'severity': value['severity'],
        'count': value['count'],
        'message': value['message'],
        'details': value['details'],
    };
}

